if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.variantInput = this.querySelector('.sticky-atc__variant-id');
        this.priceEl = this.querySelector('.sticky-atc__price');
        this.variantEl = this.querySelector('.sticky-atc__variant');
        this.submitButton = this.querySelector('.sticky-atc__button');
        this.buttonText = this.querySelector('.sticky-atc__button-text');
        this.form = this.querySelector('form');

        this.strings = {
          addToCart: this.dataset.addToCart || 'Añadir al carrito',
          soldOut: this.dataset.soldOut || 'Agotado',
          unavailable: this.dataset.unavailable || 'No disponible',
        };
      }

      connectedCallback() {
        // Show sticky bar only when BOTH:
        //   (a) the main CTA has scrolled off-screen, AND
        //   (b) the user has scrolled past 30% of the viewport height.
        // This prevents the bar appearing when the picker expands inline near
        // the top of the page (CTA goes off-screen but user hasn't engaged).
        this.scrollThresholdRatio = 0.30;
        this.isCtaOffscreen = false;
        this.hasScrolledEnough = false;

        this.setupIntersectionObserver();
        this.setupScrollThreshold();
        this.setupVariantSync();
        this.setupFormSubmit();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.scrollUnsub?.();
        this.variantChangeUnsub?.();
      }

      updateVisibility() {
        if (this.isCtaOffscreen && this.hasScrolledEnough) {
          this.setAttribute('visible', '');
        } else {
          this.removeAttribute('visible');
        }
      }

      setupIntersectionObserver() {
        const mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!mainButton) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.isCtaOffscreen = !entry.isIntersecting;
            this.updateVisibility();
          },
          { threshold: 0 }
        );

        this.observer.observe(mainButton);
      }

      setupScrollThreshold() {
        const checkScroll = () => {
          this.hasScrolledEnough =
            window.scrollY > window.innerHeight * this.scrollThresholdRatio;
          this.updateVisibility();
        };
        window.addEventListener('scroll', checkScroll, { passive: true });
        checkScroll();
        this.scrollUnsub = () => window.removeEventListener('scroll', checkScroll);
      }

      setupVariantSync() {
        this.variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const { data } = event;
          if (data.sectionId !== this.sectionId) return;

          const variant = data.variant;
          if (!variant) {
            this.submitButton.setAttribute('disabled', '');
            this.buttonText.textContent = this.strings.unavailable;
            if (this.variantEl) this.variantEl.textContent = '';
            return;
          }

          // Update variant ID
          this.variantInput.value = variant.id;

          // Update price
          if (this.priceEl) {
            this.priceEl.textContent = Shopify.formatMoney(variant.price);
          }

          // Update variant name
          if (this.variantEl) {
            this.variantEl.textContent = variant.title;
          }

          // Update button state
          if (variant.available) {
            this.submitButton.removeAttribute('disabled');
            this.buttonText.textContent = this.strings.addToCart;
          } else {
            this.submitButton.setAttribute('disabled', '');
            this.buttonText.textContent = this.strings.soldOut;
          }
        });
      }

      setupFormSubmit() {
        if (!this.form) return;

        this.form.addEventListener('submit', (evt) => {
          evt.preventDefault();
          if (this.submitButton.hasAttribute('disabled')) return;

          this.submitButton.classList.add('loading');
          this.submitButton.setAttribute('aria-disabled', 'true');

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (cart) {
            formData.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          let hasError = false;

          fetch(routes.cart_add_url, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                hasError = true;
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'sticky-add-to-cart',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                return;
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sticky-add-to-cart',
                productVariantId: formData.get('id'),
                cartData: response,
              });

              if (cart) {
                cart.renderContents(response);
              }
            })
            .catch((e) => {
              hasError = true;
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');

              const originalText = this.buttonText.textContent;
              if (hasError) {
                this.buttonText.textContent = 'Error - inténtalo de nuevo';
              } else {
                this.buttonText.textContent = this.submitButton.dataset.addedText || '\u2713 A\u00f1adido';
              }
              setTimeout(() => {
                this.buttonText.textContent = originalText;
              }, 1500);
            });
        });
      }
    }
  );
}
